module.exports = __webpack_public_path__ + "img/fig13.99742d64.jpg";